module.exports = __webpack_public_path__ + "ploni-aaa-900.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-900.otf
// module id = 1203
// module chunks = 10